import axios from 'axios';
import { ICrudDeleteAction, ICrudGetAction, ICrudPutAction, IPayloadResult } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';

import { defaultValue, IMmamaEntityDetail } from 'app/shared/model/mmama-entity-detail.model';
import { IPayload } from 'react-jhipster/src/type/redux-action.type';
import { IMmamaEntityMaster } from 'app/shared/model/mmama-entity-master.model';

export const ACTION_TYPES = {
  FETCH_ENTITY_LIST: 'mmama-entity/FETCH_ENTITY_LIST',
  FETCH_MASTER_ENTITY_LIST: 'mmama-entity/FETCH_MASTER_ENTITY_LIST',
  FETCH_MASTER_ENTITY_LIST_BY_NAMES: 'mmama-entity/FETCH_MASTER_ENTITY_LIST_BY_NAMES',
  FETCH_MASTER_ENTITY_LIST_BY_GROUP_NAMES: 'mmama-entity/FETCH_MASTER_ENTITY_LIST_BY_GROUP_NAMES',
  FETCH_ENTITY: 'mmama-entity/FETCH_ENTITY',
  FETCH_MASTER_ENTITY: 'mmama-entity/FETCH_MASTER_ENTITY',
  UPDATE_MASTER_ENTITY: 'mmama-entity/UPDATE_MASTER_ENTITY',
  CREATE_ENTITY: 'mmama-entity/CREATE_ENTITY',
  UPDATE_ENTITY: 'mmama-entity/UPDATE_ENTITY',
  DELETE_ENTITY: 'mmama-entity/DELETE_ENTITY',
  RESET: 'mmama-entity/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMmamaEntityDetail>,
  entity: defaultValue,
  masterEntities: [] as ReadonlyArray<IMmamaEntityMaster>,
  masterEntity: {} as IMmamaEntityMaster,
  masterEntitiesByGroup: {},
  updating: false,
  updateSuccess: false,
  deleteFailure: false
};

export type MmamaEntityState = Readonly<typeof initialState>;

// Reducer

export default (state: MmamaEntityState = initialState, action): MmamaEntityState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ENTITY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_NAMES):
    case REQUEST(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_GROUP_NAMES):
    case REQUEST(ACTION_TYPES.FETCH_ENTITY):
    case REQUEST(ACTION_TYPES.FETCH_MASTER_ENTITY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        deleteFailure: false
      };
    case REQUEST(ACTION_TYPES.CREATE_ENTITY):
    case REQUEST(ACTION_TYPES.UPDATE_ENTITY):
    case REQUEST(ACTION_TYPES.UPDATE_MASTER_ENTITY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case REQUEST(ACTION_TYPES.DELETE_ENTITY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
        deleteFailure: false
      };
    case FAILURE(ACTION_TYPES.FETCH_ENTITY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_NAMES):
    case FAILURE(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_GROUP_NAMES):
    case FAILURE(ACTION_TYPES.FETCH_ENTITY):
    case FAILURE(ACTION_TYPES.CREATE_ENTITY):
    case FAILURE(ACTION_TYPES.UPDATE_ENTITY):
    case FAILURE(ACTION_TYPES.FETCH_MASTER_ENTITY):
    case FAILURE(ACTION_TYPES.UPDATE_MASTER_ENTITY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case FAILURE(ACTION_TYPES.DELETE_ENTITY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        deleteFailure: true,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_ENTITY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST):
    case SUCCESS(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_NAMES):
      return {
        ...state,
        loading: false,
        masterEntities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_GROUP_NAMES):
      return {
        ...state,
        loading: false,
        masterEntitiesByGroup: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_ENTITY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_MASTER_ENTITY):
      return {
        ...state,
        loading: false,
        masterEntity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.UPDATE_MASTER_ENTITY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        masterEntity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_ENTITY):
    case SUCCESS(ACTION_TYPES.UPDATE_ENTITY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_ENTITY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        deleteFailure: false,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...state,
        loading: false,
        errorMessage: null,
        entities: [] as ReadonlyArray<IMmamaEntityDetail>,
        masterEntities: [] as ReadonlyArray<IMmamaEntityMaster>,
        masterEntitiesByGroup: {},
        entity: defaultValue,
        masterEntity: {},
        updating: false,
        updateSuccess: false,
        deleteFailure: false
      };
    default:
      return state;
  }
};

const apiUrl = 'api/mmama-entity-details';
const masterEntityApiUrl = 'api/mmama-entity-master';

// Actions
export const getEntity: ICrudGetAction<IMmamaEntityDetail> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_ENTITY,
    payload: axios.get<IMmamaEntityDetail>(requestUrl)
  };
};

export const getMasterEntities: () => IPayload<IMmamaEntityMaster> | IPayloadResult<IMmamaEntityMaster> = () => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.FETCH_MASTER_ENTITY_LIST,
    payload: axios.get<IMmamaEntityMaster>(`${masterEntityApiUrl}?cacheBuster=${new Date().getTime()}`)
  });
};

export const getMasterEntity: ICrudGetAction<IMmamaEntityMaster> = id => ({
  type: ACTION_TYPES.FETCH_MASTER_ENTITY,
  payload: axios.get<IMmamaEntityMaster>(`${masterEntityApiUrl}/${id}?cacheBuster=${new Date().getTime()}`)
});

export const updateMasterEntity: ICrudPutAction<IMmamaEntityMaster> = entity => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.UPDATE_MASTER_ENTITY,
    payload: axios.put(masterEntityApiUrl, {
      id: entity.id,
      entityName: entity.entityName,
      stEntityName: entity.stEntityName,
      displayOrder: entity.displayOrder,
      required: !!entity.required
    })
  });
};

export const getMasterEntitiesByEnumNames: (enumNames: string[], countryId: string) => IPayload<IMmamaEntityMaster> | IPayloadResult<IMmamaEntityMaster> = (enumNames, countryId) => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_NAMES,
    payload: axios.post(`${masterEntityApiUrl}/by-enum-names`, { enumNames, countryId })
  });
};

export const getMasterEntitiesByGroupNames: (groupNames: string[], countryId: string) => IPayload<IMmamaEntityMaster> | IPayloadResult<IMmamaEntityMaster> = (groupNames, countryId) => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.FETCH_MASTER_ENTITY_LIST_BY_GROUP_NAMES,
    payload: axios.post(`${masterEntityApiUrl}/by-group-names`, { groupNames, countryId })
  });
};

export const getEntities: (countryId, masterEntityId) => IPayload<IMmamaEntityDetail> | IPayloadResult<IMmamaEntityDetail> = (countryId, masterEntityId) => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.FETCH_ENTITY_LIST,
    payload: axios.get<IMmamaEntityDetail>(`${apiUrl}?countryId=${countryId}&masterEntityId=${masterEntityId}&cacheBuster=${new Date().getTime()}`)
  });
};

export const createEntity: ICrudPutAction<IMmamaEntityDetail> = entity => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.CREATE_ENTITY,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
};

export const updateEntity: ICrudPutAction<IMmamaEntityDetail> = entity => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.UPDATE_ENTITY,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
};

export const deleteEntity: ICrudDeleteAction<IMmamaEntityDetail> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  return await dispatch({
    type: ACTION_TYPES.DELETE_ENTITY,
    payload: axios.delete(requestUrl)
  });
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
